// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"21d4edb7","247":"196cedcc","268":"b04126b7","284":"c624506d","457":"96c3135c","488":"4e0bf971","627":"32faf7f3","828":"6dac7d85","834":"1a5ff8e6","867":"5e87ab06","923":"bba276fe","938":"66615e56"}[chunkId] + ".chunk.js";
};